// import {PWMAT_RESOURCE} from './consts'

export const Camp = [{
  name:'1.电催化专题',
  url:'https://www.bilibili.com/video/BV1Tx4y1j7YY/?spm_id_from=333.999.0.0&vd_source=0bdf27b8ade1d978776892ded53af857',
  file_name:'d带中心、HER台阶图、溶剂效应、恒电势方法、OER台阶图、催化火山图、布拜图'
},
{
  name:'2.锂电池专题',
  url:'https://www.bilibili.com/video/BV1WM4y1X7wr/?spm_id_from=333.999.0.0&vd_source=0bdf27b8ade1d978776892ded53af857',
  file_name:'锂离子注入、电压演化、相图计算、NEB、Dimer方法计算锂输运'
},
{
  name:'3.半导体缺陷专题',
  url:'https://www.bilibili.com/video/BV1Ny4y1Q7rh/?spm_id_from=333.999.0.0&vd_source=0bdf27b8ade1d978776892ded53af857',
  file_name:'形成能、位形坐标及光学转变能级、点缺陷扩散、点缺陷发光机理和特征、点缺陷非辐射复合'
},
{
  name:'4.TDDFT含时密度泛函专题',
  url:'https://study.163.com/course/introduction/1213097807.htm',
  file_name:'基本原理、实时rt-TDDFT、线性响应lr-TDDFT、激发态与非绝热分子动力学'
},
]
export const qs = [{
  name:'1.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1oi4y1W7Yh/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'如何进入Q-Studio及界面简介'
},
{
  name:'2.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1ik4y1U7Wu/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'文件导入导出'
},
{
  name:'3.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1ie411Y7HY/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'原胞惯胞转换'
},
{
  name:'4.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1He411E7rx/?spm_id_from=333.337.search-card.all.click&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'建立超胞'
},
{
  name:'5.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1im41197Au/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'构建空位缺陷'
},
{
  name:'6.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1Bu4m1N78d/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'构建替位掺杂缺陷'
},
{
  name:'7.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1Sp421d7Ua/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'新建晶体结构'
},
{
  name:'8.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV12y421e75N/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'小分子建模-H2O'
},
{
  name:'9.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1WK42117Ms/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'小分子建模-C3H4O3'
},
{
  name:'10.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1Hx42197DX/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'表面构建'
},
{
  name:'11.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1BK421y7Cv/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'固定原子'
},
{
  name:'12.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1R7421P76y/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'添加单原子'
},
{
  name:'13.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1uJ4m1478x/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'添加分子'
},
{
  name:'14.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1LA4m1L73M/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'添加间隙原子'
},
{
  name:'15.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1d2421w7Kv/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'构建二维材料（单层石墨烯）'
},
{
  name:'16.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1RC411B7rs/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'晶格变换'
},
{
  name:'17.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1Tv421i75D/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'构建异质结（晶格常数相近）'
},
{
  name:'18.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV1Em41197Qt/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'构建异质结（晶格常数差异大）'
},
{
  name:'19.Q-Studio建模小技巧',
  url:'https://www.bilibili.com/video/BV12U421Z7xF/?spm_id_from=333.788&vd_source=0f10dbdf14edd24b07feb4e222bed64c',
  file_name:'构建异质结（二维材料）'
},
]
